// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"58bc66f3","675":"56ce43e0"}[chunkId] + ".chunk.js";
};